/**
 * WordPress dependencies
 */
import domReady from '@wordpress/dom-ready';

/**
 * Internal dependencies
 */
import { maybePolyfillRequestIdleCallback } from './modules/polyfills';
import { ExposeScrollbarWidth } from './modules/expose-scroll-bar-width';
import { initFaqAccordion } from './modules/faqs';
import { initNavDropdown } from './modules/nav-dropdown';
import { initNavOverlay } from './modules/nav-overlay';

domReady(async () => {
	// Polyfills
	await maybePolyfillRequestIdleCallback();

	// Load dynamic modules when the DOM elements requiring it are present on the page.
	setTimeout(async () => {
		if ( document.querySelector( '.wp-block-gallery.is-style-slider' ) ) {
			const { CoreGallery } = await import(
				/* webpackChunkName: "core-gallery" */
				'./modules/core-gallery.js'
			);
			CoreGallery.init();
		}

		if ( document.querySelector( '#dynamic-h1, #dynamic-h2' ) ) {
			const { DynamicText } = await import(
				/* webpackChunkName: "dynamic-text" */
				'./modules/dynamic-text.js'
			);
			DynamicText.init();
		}
	}, 100 );

	// Non-critical UI components.
	if (window.matchMedia('(min-width: 960px)')) {
		setTimeout(ExposeScrollbarWidth.init, 0);
	}

	initFaqAccordion();
	initNavDropdown();
	initNavOverlay();
});
